export default __webpack_public_path__ + "static/media/logo.7068d74e.svg";